export default "__VITE_ASSET__SfKRvUil__"